import template from './forbidden.html';

export default class ForbiddenComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      model: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/forbidden/forbidden-component.js